
import React from 'react';
import { SelectWidget } from 'form/Select';


export default function VatWidget(props) {
  const options = [
    {value: '0', label: '0%'},
    {value: '22', label: '22%'},
    {value: '-', label: 'Без НДС'},
  ];

  return (
    <SelectWidget
      {...props}
      options={options}
    />
  );
}
